import * as validators from '../utilities/form/formValidators';

// Define validator types.
const inputLength = (formValues, id, validator, child) => {
  const input = formValues[id];
  // Only validate if required or has value.
  if (child.required || input) {
    const validatorValues = validator.values ? validator.values[0] : 2;
    return validators.validateInputLength(input, validatorValues);
  }
  return true;
};

/**
 * This validator validates the range [min - max], works for type="number"
 * min <= inputValue >= max
 * @param formValues
 * @param id
 * @param validator
 * @param child
 * @returns {boolean}
 */
const numberBetween = (formValues, id, validator, child) => {
  const input = formValues[id];
  // Only validate if required or has value.
  if ((child.required || input) &&
      (validator && validator.values && validator.values.length >= 2)) {
    const minRange = validator.values[0];
    const maxRange = validator.values[1] ? validator.values[1] : minRange;
    return validators.validateNumberBetweenRange(input, minRange, maxRange);
  }
  return true;
};

const phoneNumber = (formValues, id, child) => {
  const input = formValues[id];
  if (child.required || input) {
    return validators.validatePhoneNumber(input);
  }
  return true;
};

const email = (formValues, id) => {
  const input = formValues[id];
  return validators.validateEmail(input);
};

const lettersOnly = (formValues, id) => {
  const input = formValues[id];
  return !validators.validateInputNumberOnly(input);
};

const regexFullName = (formValues, id) => {
  const input = formValues[id];
  const namePattern = /^([A-z\'\.-ᶜ]*(\s))+[A-z\'\.-ᶜ]*$/;
  return !validators.validateInputNumberOnly(input) && namePattern.test(input);
};
const numberOnly = (formValues, id) => {
  const input = formValues[id];
  return validators.validateInputNumberOnly(input);
};

const blocker = (formValues, id, validator) => {
  const input = formValues[id];
  const validatorValues = validator.values ? validator.values : [];
  return validators.validateBlocker(input, validatorValues);
};

const formHasValues = (formValues, id, validator, child) => {
  if (child.required) {
    return validators.formHasValues(formValues, child.formValues);
  }
  return true;
};

const formHasAnyValues = (formValues, id, validator, child) => {
  return validators.formHasAnyValues(formValues, child.formValues);
};

const cpr = (formValues) => {
  const input = formValues.civilRegistrationNumber;
  return validators.validateCpr(input);
};

const minDate = (formValues, id, validator) => {
  const input = formValues[id];
  return validators.validateMinDate(input, formValues, validator.values[0], validator.values[1]);
};

const maxDate = (formValues, id, validator) => {
  const input = formValues[id];
  return validators.validateMaxDate(input, formValues, validator.values[0], validator.values[1]);
};

const validDate = (formValues, id) => {
  const input = formValues[id];
  return validators.isValidDate(input);
};

export const validatorMap = {
  blocker,
  email,
  formHasValues,
  formHasAnyValues,
  inputLength,
  lettersOnly,
  regexFullName,
  numberOnly,
  phoneNumber,
  cpr,
  minDate,
  maxDate,
  numberBetween,
  validDate,
};
